<template>
  <div class="page-body">
  <div ui-view="" class="app-body" id="view">
    <page-header title="출입 통계" description="출입자 통계 자료입니다.">
    </page-header>

    <div class="page-body p-30">

      <div class="row">

        <!--실시간 입퇴실-->
        <div class="col-xl-6 col-6 mb-30">
          <statics-box title="실시간 입/퇴실 현황" :subTitle="getDateSimpleStr(new Date())" :isYearDropdown="false" @changeIdc="getTodayVisitorCnt">
            <template slot="chart">
              <div class="col-4 text-center">
                <pie-chart :denominator="todayVisitorCnt.reserve" :numerator="todayVisitorCnt.checkIn" measure="명" title="방문객 입실"/>
                <button class="btn btn-md line-2 mt-15">예약자 목록
                  <i class="icon-move-link ml-5"></i>
                </button>
              </div>

              <div class="col-8 text-center">
                <div class="row" style="height:167px;">
                  <div class="col-6 text-center" style="border-left: 1px solid #e2e2e2;">
                    <pie-chart :denominator="todayVisitorCnt.checkIn" :numerator="todayVisitorCnt.checkOut" measure="명" title="방문객 퇴실"/>
                  </div>

                  <div class="col-6 text-center" style="border-left: 1px solid #e2e2e2;">
                    <pie-chart :denominator="todayVisitorCnt.empCheckIn" :numerator="todayVisitorCnt.empCheckOut" measure="명" title="AB등급 퇴실"/>
                  </div>
                </div>
                <div class="row" style="height:50px;">
                  <div class="col-12 text-center" style="border-left: 1px solid #e2e2e2;">
                    <button class="btn btn-md line-2 mt-15">출입자 목록
                      <i class="icon-move-link ml-5"></i>
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </statics-box>
        </div>

        <div class="col-xl-6 col-6 mb-30">
          <statics-box title="당일 출입자 현황" :subTitle="getDateSimpleStr(new Date())" :isYearDropdown="false" :isIdcDropdown="false">
            <template slot="chart" >
              <div class="col-12 text-center">
                <stacked-column :categories="visitorTypeIdc" :series="visitorTypeSeries"/>
              </div>
            </template>
          </statics-box>
        </div>

        <!--<div class="col-xl-6 col-6 mb-30">-->
          <!--<statics-box title="당일 출입자 현황" subTitle="2021년 10월 19일" :isYearDropdown="false" :isIdcDropdown="false">-->
            <!--<template slot="chart" slot-scope="slotProps">-->
              <!--<chart-01 :year="slotProps.selectedYear" :idc="slotProps.selectedIdc"/>-->
            <!--</template>-->
          <!--</statics-box>-->
        <!--</div>-->
      </div>



      <div class="row">
        <!--누적 출입자 수-->
        <div class="col-xl-6 col-6 mb-30">
          <statics-box title="누적 출입자 수" subTitle="0000년 00월 00일" :isIdcDropdown="false" @changeYear="getMonthlyStatstics" :isAllYear="false">
            <template slot="chart" >
              <div class="col-12 text-center">
                <stacked-area :series="idcStackedSeries"/>
              </div>
            </template>
          </statics-box>
        </div>

        <!--IDC 출입 업체 TOP 20-->
        <div class="col-xl-6 col-6 mb-30">
          <statics-box title="IDC 출입 업체 TOP 20" subTitle="0000년 00월 00일" :isAllYear="false" :startYear="2022" @changeYear="getCompanyStatistics" @changeIdc="getCompanyStatistics">
            <template slot="chart" >
              <div class="col-12 text-center">
                <rotated-labels :series="idcRotatedSeries"/>
              </div>
            </template>
          </statics-box>
        </div>
      </div>



      <div class="row">
        <!--방문 목적 분포도-->
        <div class="col-xl-3 col-6 mb-30">
          <statics-box title="방문 목적 분포도" subTitle="0000년 00월 00일" :isAllYear="false" @changeYear="getTypeStatstics" @changeIdc="getTypeStatstics">
            <template slot="chart" >
              <div class="col-12 text-center">
                <chart-03 :series="idcTypePieSeries"/>
              </div>
            </template>
          </statics-box>
        </div>

        <!--목절별 누적 출입자 수-->
        <div class="col-xl-6 col-6 mb-30">
          <statics-box title="방문 목적 별 누적 출입자 수" subTitle="0000년 00월 00일" :isAllYear="false" @changeYear="getMonthlyTypeStatistics" @changeIdc="getMonthlyTypeStatistics">
            <template slot="chart" >
              <div class="col-12 text-center">
                <stacked-area :series="typeStackedSeries"/>
              </div>
            </template>
          </statics-box>
        </div>


        <!--내부 직원 방문 비율-->
        <div class="col-xl-3 col-6 mb-30">
          <statics-box title="내부 직원 방문 비율" subTitle="0000년 00월 00일" :isAllYear="false" :startYear="2022" @changeYear="getNaverStatistics" @changeIdc="getNaverStatistics">
            <template slot="chart" >
              <div class="col-12 text-center">
                <chart-03 :series="naverPieSeries"/>
              </div>
            </template>
          </statics-box>
        </div>
      </div>

    </div>
    <!--<div class="page-body pt-30 ph-30">-->
      <!--<div class="box mt-20">-->
        <!--<chart-01/>-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="page-body pt-30 ph-30">-->
      <!--<div class="box mt-20">-->
        <!--<chart-02/>-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="page-body pt-30 ph-30">-->
      <!--<div class="box mt-20">-->
        <!--<chart-03/>-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="page-body pt-30 ph-30">-->
      <!--<div class="box mt-20">-->
        <!--<chart-04/>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</div>
</template>

<script>
import PageHeader from '../../../layout/PageHeader.vue'
import StackedColumn from './StackedColumn.vue'
import Chart02 from './Chart02.vue'
import Chart03 from './Chart03.vue'
import PieChart from './PieChart.vue'
import StackedArea from './StackedArea.vue'
import RotatedLabels from './RotatedLabels.vue'
import StaticsBox from '@/components/StatisticsBox.vue';

export default {
  components: {
    PageHeader,
    StackedColumn,
    Chart02,
    Chart03,
    PieChart,
    StackedArea,
    RotatedLabels,
    StaticsBox
  },
  data() {
    return {
      todayVisitorCnt : {
        checkIn : null,
        checkOut: null,
        empCheckIn: null,
        empCheckOut: null,
        reserve : null
      },
      visitorTypeIdc: null,
      visitorTypeSeries : null,
      idcStackedSeries: null,
      idcRotatedSeries: null,
      idcTypePieSeries: null,
      typeStackedSeries: [],
      naverPieSeries: null
    }
  },
  computed : {

  },
  mounted() {

    let currentIdc = this.$store.getters['location/currentIdc'].locationCode;
    let year = new Date().getFullYear();

    //TODO 초기 IDC 세팅 - 주 IDC 로
    this.getTodayVisitorCnt(currentIdc);
    this.getTodayVisitorTypeCnt();
    this.getMonthlyStatstics(year);
    this.getCompanyStatistics(currentIdc,year);
    this.getTypeStatstics(currentIdc, year);
    this.getMonthlyTypeStatistics(currentIdc, year);
    this.getNaverStatistics(currentIdc, year);

  },
  methods: {
    //실시간 입퇴실 현황
    getTodayVisitorCnt(locationCode) {
      this.$http.get('/api/private/statics/today/'+locationCode)
              .then((result) => {
                this.todayVisitorCnt = result.data;
              }).catch((e) =>{
                console.log(e);
              })
    },

    //당일 출입자 현황
    getTodayVisitorTypeCnt() {

      this.$http.get('/api/private/statics/today/type').then((result) =>{

        //중복 제거 IDC 목록 추출
        this.visitorTypeIdc = [...new Set(result.data.map(data => {
          return data.locationName;
        }))];

        let type = [...new Set(result.data.map(data => {
          return data.visitTypeStr;
        }))];

        this.visitorTypeSeries = type.map(x => {
          return {name: x, data: []}
        })

        result.data.forEach(data => {
          let idcIdx = this.visitorTypeIdc.indexOf(data.locationName);
          let typeIdx = type.indexOf(data.visitTypeStr);

          this.visitorTypeSeries[typeIdx].data[idcIdx] = data.count;
        })


      })
    },

    //누적 출입자 수
    getMonthlyStatstics(year){
      this.$http.get('/api/private/statics/month/'+year).then((result) =>{
        let idcSum = {};

        // 각 IDC 의 월별 출입자 수
        let idcStastics = result.data.reduce((acc, data, idx) => {

          if(!data.location) return acc;

          if(acc.hasOwnProperty(data.location.locationName)){
            if(acc[data.location.locationName].hasOwnProperty(data.yyyymm)){
              acc[data.location.locationName][data.yyyymm] = acc[data.location.locationName][data.yyyymm] + data.count;
            }
            else{
              acc[data.location.locationName][data.yyyymm] = data.count;
            }
          }else{
            acc[data.location.locationName] = {};
            acc[data.location.locationName][data.yyyymm] = data.count;
          }

          return acc;
        }, idcSum);


        //차트에 필요한 형식에 맞게 변경
        let idcStaticsSeries = [];
        // this.idcStackedSeries = [];
        for(const [idc, idcData] of Object.entries(idcStastics)){

          let obj = {name: idc, data: []};

          //배열 초기화
          if(new Date().getFullYear() == year){
            for(let i = 0 ; i < new Date().getMonth()+1 ; i++){
              obj.data[i] = 0;
            }
          }
          else{
            obj.data = [0,0,0,0,0,0,0,0,0,0,0,0]
          }

          for(const [yyyymm, count] of Object.entries(idcData)){

            let idx = parseInt(yyyymm.split('-')[1]) -1;

            if(idx == 0) obj.data[idx] = count;
            else{
              // if(!obj.data[idx-1]) obj.data[idx-1] = 0;
              obj.data[idx] = count + obj.data[idx-1];
            }

          }
          idcStaticsSeries.push(obj);
        }
        this.idcStackedSeries = idcStaticsSeries;

      });
    },

    //출입업체 TOP 20
    getCompanyStatistics(locationCode, year){
      this.$http.get('/api/private/statics/company/'+locationCode+'/'+year).then((result) =>{
        this.idcRotatedSeries = result.data.map(data => {
          return [data.company, data.cnt]
        }).slice(0,20)
      });
    },

    //방문목적 분포도
    getTypeStatstics(locationCode, year){
      this.$http.get('/api/private/statics/month/'+year).then((result) =>{
        let temp = result.data.filter(data => {
            return data.locationCode == locationCode;
          }).map(data => {
            return {
              type: data.visitType.visitTypeStr,
              count: data.count
            };
          }).reduce((acc, data, idx) => {
            if(!acc[data.type]) acc[data.type] = data.count;
            else acc[data.type] = acc[data.type] + data.count;
            return acc;
          }, {});


        this.idcTypePieSeries = [];
        for(const [type, cnt] of Object.entries(temp)){
          if(cnt > 0) this.idcTypePieSeries.push([type, cnt]);
        }

      });
    },

    //붕문 목적 별 누적 출입자 수
    getMonthlyTypeStatistics(locationCode, year){
      this.$http.get('/api/private/statics/month/'+year).then((result) =>{

        this.typeStackedSeries = [];

        //Series Data 초기화
        let filterdIdcData = result.data.filter(data => {
          return data.locationCode == locationCode && data.count > 0;
        });

        let typeSet = filterdIdcData.reduce((acc,data) => {
          acc.add(data.visitType.visitTypeStr)
          return acc;
        }, new Set());

        typeSet.forEach((value) => {
          let obj = {name: value, data: []};
          if(new Date().getFullYear() == year){
            for(let i = 0 ; i < new Date().getMonth()+1 ; i++){
              obj.data[i] = 0;
            }
          }
          else{
            obj.data = [0,0,0,0,0,0,0,0,0,0,0,0];
          }
          this.typeStackedSeries.push(obj);
        });


        filterdIdcData.reduce((acc,data,idx) => {
          let accSelect = acc.filter(x => {
            return x.name == data.visitType.visitTypeStr;
          });

          let accDataIdx = parseInt(data.yyyymm.split('-')[1])-1;

          accSelect[0].data[accDataIdx] = data.count;

          return acc;
        }, this.typeStackedSeries);

        //적산값으로 변경
        this.typeStackedSeries.forEach(data => {
          for(let i = 0 ; i < data.data.length ; i++){
            if(i > 0) data.data[i] = data.data[i-1] + data.data[i];
          }
        });

      });
    },

    getNaverStatistics(locationCode, year){

      this.$http.get('/api/private/statics/company/'+locationCode+'/'+year).then((result) =>{
        let temp = result.data.map(data => {
          return {
            type: data.isNaver == 1 ? '내부직원' : '외부출입자',
            count: data.cnt
          }
        }).reduce((acc,data) => {
          if(!acc[data.type]) acc[data.type] = data.count;
          else acc[data.type] = acc[data.type] + data.count;

          return acc;
        }, {});

        this.naverPieSeries = [];
        for(const [type, cnt] of Object.entries(temp)){
          if(cnt > 0) this.naverPieSeries.push([type, cnt]);
        }

      });

    },
  }
}

</script>

<style>

</style>


